export const X_PATTERN_CELL_INDICES: readonly number[] = [0, 2, 4, 6, 8];

export const H_PATTERN_CELL_INDICES: readonly number[] = [0, 2, 3, 4, 5, 6, 8];

export const HOV_O_LABEL_HOVER_TARGET_SECONDS = 3;

export const OBSERVER_TARGET_SECONDS = 30;

export interface SecretProgressTimers {
  readonly continuousPointerSeconds: number;
  readonly observerSeconds: number;
  readonly xPatternSeconds: number;
  readonly hPatternSeconds: number;
  readonly hovOLabelHoverSeconds: number;
}

export function resolveSecretProgressTimers(input: {
  readonly current: SecretProgressTimers;
  readonly dtSeconds: number;
  readonly isHoveringHov: boolean;
  readonly isHovTargetScreenActive: boolean;
  readonly didEarnHovThisTick: boolean;
  readonly activeHovCellIndices: readonly number[];
  readonly hoveringHovCellIndex: number | null;
  readonly isHoveringHovOLabel: boolean;
}): SecretProgressTimers {
  const anyPointer =
    input.isHoveringHov || input.activeHovCellIndices.length > 0;
  const activeSet = new Set<number>(input.activeHovCellIndices);
  if (input.hoveringHovCellIndex !== null) {
    activeSet.add(input.hoveringHovCellIndex);
  }
  const xMatches =
    activeSet.size === X_PATTERN_CELL_INDICES.length &&
    X_PATTERN_CELL_INDICES.every((index) => activeSet.has(index));
  const hMatches =
    activeSet.size === H_PATTERN_CELL_INDICES.length &&
    H_PATTERN_CELL_INDICES.every((index) => activeSet.has(index));

  return {
    continuousPointerSeconds: anyPointer
      ? input.current.continuousPointerSeconds + input.dtSeconds
      : 0,
    observerSeconds:
      input.isHovTargetScreenActive && !input.didEarnHovThisTick
        ? input.current.observerSeconds + input.dtSeconds
        : 0,
    xPatternSeconds: xMatches
      ? input.current.xPatternSeconds + input.dtSeconds
      : 0,
    hPatternSeconds: hMatches
      ? input.current.hPatternSeconds + input.dtSeconds
      : 0,
    hovOLabelHoverSeconds: input.isHoveringHovOLabel
      ? Math.min(
          HOV_O_LABEL_HOVER_TARGET_SECONDS,
          input.current.hovOLabelHoverSeconds + input.dtSeconds,
        )
      : 0,
  };
}
